const ATTENTION_FAVICON_PATH = "/assets/favicon-attention.png";
const ATTENTION_FAVICON_URL = new URL(ATTENTION_FAVICON_PATH, window.location.origin).toString();

export function solidAttentionPlaceholderDataUrl(): string {
  return ATTENTION_FAVICON_URL;
}

/**
 * Uses a static attention favicon URL generated once at build time.
 */
export async function buildAttentionFaviconDataUrlFromHref(_baseHref: string): Promise<string> {
  return ATTENTION_FAVICON_URL;
}
